(() => {
  const init = (root) => {
    if (!root || !root.matches('[data-tan-retail-journey]') || root.dataset.retailJourneyReady) return;
    root.dataset.retailJourneyReady = 'true';

    const preview = root.querySelector('[data-retail-journey-preview]');
    const choices = Array.from(root.querySelectorAll('[data-retail-touchpoint-choice]'));
    const glare = root.querySelector('[data-retail-glare]');
    const glareValue = root.querySelector('[data-retail-glare-value]');
    const resultHeading = root.querySelector('[data-retail-touchpoint-heading]');
    const resultCopy = root.querySelector('[data-retail-touchpoint-copy]');
    const resultList = root.querySelector('[data-retail-touchpoint-list]');

    const updateChoice = (choice) => {
      if (!choice || !preview) return;
      choices.forEach((item) => {
        const active = item === choice;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
      preview.dataset.mode = choice.dataset.modeKey || 'window';
      if (resultHeading) resultHeading.textContent = choice.dataset.touchpointTitle || '';
      if (resultCopy) resultCopy.textContent = choice.dataset.touchpointNote || '';

      const payload = root.querySelector(`[data-retail-touchpoint-payload="${CSS.escape(choice.dataset.touchpointId || '')}"]`);
      const content = payload?.content.querySelector('[data-retail-touchpoint-checklist]');
      if (resultList && content) resultList.innerHTML = content.innerHTML;

      ['viewer', 'constraint', 'evidence'].forEach((metric) => {
        const label = root.querySelector(`[data-retail-metric-label="${metric}"]`);
        const value = root.querySelector(`[data-retail-metric-value="${metric}"]`);
        if (label) label.textContent = choice.dataset[`${metric}Label`] || '';
        if (value) value.textContent = choice.dataset[`${metric}Value`] || '';
      });
    };

    const updateGlare = () => {
      if (!glare || !preview) return;
      const strength = Number(glare.value) / 100;
      preview.style.setProperty('--retail-glare', String(0.08 + strength * 0.72));
      preview.style.setProperty('--retail-glow', String(0.7 + (1 - strength) * 0.3));
      if (glareValue) glareValue.textContent = `${glare.value}%`;
    };

    choices.forEach((choice) => choice.addEventListener('click', () => updateChoice(choice)));
    glare?.addEventListener('input', updateGlare);
    updateGlare();
  };

  const initAll = (scope = document) => {
    if (scope.matches?.('[data-tan-retail-journey]')) init(scope);
    scope.querySelectorAll?.('[data-tan-retail-journey]').forEach(init);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
